/* eslint-disable max-lines */
/* eslint-disable max-lines-per-function */
/* eslint-disable no-undef */
$(document).ready(function() {
  /* eslint-disable vars-on-top */
  /* eslint-disable xss/no-mixed-html */
/* eslint-disable id-match*/
  PHI.shoppinglist = {

    bindShoppingList: function() {
      var $listContainer = $('.ph-addtoshoppinglist-container');

      $.each($('.ph-addtoshoppinglist-container'), function() {
        /* eslint-disable no-use-before-define */
        addToShoppingList(this);
        /* eslint-enable no-use-before-define */
      });

      function addToShoppingList(element) {
        var $element = $(element);

        $('.myshopping-newshoppinglist').click(function() {
          $listContainer.toggle();
        });

        $('.ph-closeaddtoshoppingList').click(function() {
          $listContainer.toggle();
        });

        $('.clear-list', $element).click(function() {
          $('.createnewlist-txt', $element).val('');
        });
      }

      $('.rl-trim').each(function() {
        var actualText = $.trim($(this).find('a').text());
        /* eslint-disable no-use-before-define*/
        var slicedText = sliceText(actualText, actualText.length, 15);
        /* eslint-enable no-use-before-define*/

        $(this).find('a').html(slicedText);
      });

      function sliceText(origTextArray, textLength, length) {
        /* eslint-disable init-declarations*/
        var newText;

        /* eslint-enable init-declarations*/
        if (textLength >= length) {
          newText = String(origTextArray.substr(0, length)) + '..';
        }

        return newText;
      }

      $('#createNewListButton').click(function() {
        var listname = $('#newListName').val();
        var $list = $('.addtoshoppinglist li a');

        if (PHI.shoppinglist.isNameExistsInList(listname, $list)) {
          $.colorbox({
            width: '400px',
            maxWidth: '90%',
            html: $('.ph-popupError').html(),
            overlayClose: true,
            closeButton: false,
            onClosed: function() {
              ACC.common.refreshScreenReaderBuffer();
            }
          });
        } else if (listname !== null && listname.trim() !== null && listname.trim() !== '') {
          PHI.shoppinglist.disableCreateNewList();

          /* eslint-disable no-useless-escape */
          listname = listname.replace(/[^a-zA-Z0-9 \-\_]/g, '');
          listname = listname.replace(/\s{2,}/g, ' ');

          /* eslint-enable no-useless-escape*/

          listname = listname.trim();
          $.ajax({
            url: ACC.config.encodedContextPath + '/shoppinglist/storeCart',
            data: {
              shoppingListName: listname
            },
            type: 'POST',
            datatype: 'json',
            /* eslint-disable  max-statements*/
            success: function(result) {
              var alreadyExists = 0,
                  length = $('.addtoshoppinglist li').length,
                  obj = $.parseJSON(JSON.stringify(result)),
                  $element = '',
                  dataList = 'data-list';

              for (var ind = 0; ind < length; ind = ind + 1) {
                var listId = '#shoppingList' + ind,
                    list = $(listId).attr(dataList + 'Name');

                if (typeof list !== 'undefined' && listname.toLowerCase() === list.toLowerCase()) {
                  alreadyExists = 1;
                  $('#shoppingListProductcount' + ind).text('(' + obj.orderProductCount + ')');

                  break;
                }
              }

              $('#addtoshoppinglist-link').toggleClass('ph-toggle_border');
              $listContainer.toggle();

              $.colorbox({
                width: '400px',
                maxWidth: '90%',
                html: $('.ph-popupSuccess').html(),
                overlayClose: true,
                closeButton: false,
                onClosed: function() {
                  ACC.common.refreshScreenReaderBuffer();
                }
              });


              if (alreadyExists === 0) {
                var prependList = obj.orderName;

                if (prependList.length > 15) {
                  prependList = prependList.substring(0, 15) + '..';
                }

                /* eslint-disable no-useless-concat */
                /* eslint-disable max-len */
                var newItem = '<li>' + '<a href=\'javascript:void();\' class=\'shoppingListName\' id=\'shoppingList' + length + '\' data-listName=\'' + obj.orderName + '\'>' + prependList + '</a>' + '<button type="button" class="ph-delete-list" data-productid="' + obj.orderName + '" href="javascript:void(0);"></button>' +
'<span class=\'addtoshoppinglist-count\'>(' + obj.orderProductCount + ')</span>' + '</li>';

                /* eslint-enable max-len */
                /* eslint-enable no-useless-concat*/
                $('.addtoshoppinglist').prepend(newItem);
              }

              $('.createnewlist-txt', $element).val('');

              setTimeout(function() {
                $('#white_content')
                  .fadeOut();
              }, 5000);
            },
            error: function() {
              PHI.shoppinglist.enableCreateNewList();
            }
          });
        }

        $('#createNewListButton').click(function() {
          $('.addtoshoppinglist li:even').removeClass('sam').removeClass('sams').addClass('sam');
          $('.addtoshoppinglist li:odd').removeClass('sam').removeClass('sams').addClass('sams');
        });
      });

      $('.shoppingListName').click(function() {
        var listname = $(this).attr('data-listName');
        var listNumber = $(this).attr('data-listNumber');

        $.ajax({
          url: ACC.config.encodedContextPath + '/shoppinglist/storeCart',
          data: {
            shoppingListName: listname
          },
          type: 'POST',
          datatype: 'json',
          success: function(result) {
            $listContainer.toggle();

            var obj = $.parseJSON(JSON.stringify(result));
            var spanId = 'shoppingListProductcount' + listNumber;

            $('#' + spanId).html('(' + obj.orderProductCount + ')');

            $.colorbox({
              width: '400px',
              maxWidth: '90%',
              html: $('.ph-popupSuccess').html(),
              overlayClose: true,
              closeButton: false,
              onClosed: function() {
                ACC.common.refreshScreenReaderBuffer();
              }
            });
          },
          error: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      });

      $(document).on('click', '.addtoshoppinglist .ph-delete-list', function() {
        $('#favRemoveCode').val($(this).attr('data-productid'));
        $.colorbox({
          width: '500px',
          maxWidth: '90%',
          height: '150px',
          html: $('.ph-popupListDeleteConfirm').html(),
          overlayClose: false,

          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      });

      $('.createnewlist-txt').attr({
        maxLength: 30
      });
      $('.addtoshoppinglist li:even').removeClass('sam').removeClass('sams').addClass('sam');
      $('.addtoshoppinglist li:odd').removeClass('sam').removeClass('sams').addClass('sams');
    },

    /* Shoppinglist-popup.js*/

    bindShoppingListPopup: function() {
      $('.fev_button_event').click(function() {
        $('.loader').show();
        $('.wait-message').show();
      });

      $('#createNewListButton-shoppingList').click(function() {
        var listname = $('#newListName-shoppingList').val(),
            disab = 'disable',
            $list = $('.myshopping-list-names-tbl-prd');

        if (PHI.shoppinglist.isNameExistsInList(listname, $list)) {
          $('.ph-negative').show();
        } else if (listname !== null && listname.trim() !== null && listname.trim() !== '') {
          PHI.shoppinglist.disableCreateNewList();
          listname = listname.replace(/\s{2,}/g, ' ');
          listname = listname.trim();

          if ((/[&\\#,+()=|`$@!~%.'":*?^<>{}]/g).test(listname) === true || listname.trim() === '') {
            $('.ph-emptyListName').show();
            PHI.shoppinglist.enableCreateNewList();
            $('.createnewlist-btn').removeClass('ph-' + disab + '-button');
          } else {
            $('.createnewlist-txt').removeAttr('disabled');
            $('#createNewListForm').submit();
          }
        }
      });

      /* eslint-disable consistent-return */
      $('#addListToCartForm').on('keyup keypress keydown', function(event) {
        var code = event.keyCode || event.which;
        /* eslint-enable consistent-return */

        if (code === 13) {
          event.preventDefault();

          return false;
        }
      });

      function clearPopup() {
        $('.myshopping-list-names-tbl-prd').css('text-decoration', 'none');
        $('.myshoppinglist-popup.visible').addClass('transitioning').removeClass('visible');
        $('html').removeClass('overlay');

        setTimeout(function() {
          $('.myshoppinglist-popup').removeClass('transitioning');
        }, 200);
      }

      $(document).keyup(function(event) {
        if (event.keyCode === 27 && $('html').hasClass('overlay')) {
          clearPopup();
        }
      });

      $('.popup-exit').click(function() {
        clearPopup();
      });

      $('.popup-overlay').click(function() {
        clearPopup();
      });
    },

    disableCreateNewList: function() {
      var disbe = 'disable';

      $('.createnewlist-btn').removeClass('group-blue-2').addClass('ph-' + disbe + '-button');
      $('.createnewlist-txt').attr('disabled', 'disabled');
      $('.clear-list').addClass('default-cursor');
    },

    enableCreateNewList: function() {
      $('.createnewlist-txt').removeAttr('disabled');
      $('.clear-list').removeClass('default-cursor');
    },

    changeProductCheck: function() {
      var listName = $(this).attr('list-name');
      var listNameWithoutSpace1 = listName.replace(/\s+/g, '');
      var $allProductCheckBoxes = $('.checkbox-' + listNameWithoutSpace1);

      for (var intg = 0; intg <= $allProductCheckBoxes.length; intg = intg + 1) {
        $allProductCheckBoxes[intg].checked = $(this).prop('checked');
        /* eslint-disable no-use-before-define */
        checkBoxHandling($allProductCheckBoxes[intg]);
      }
    },

    isNameExistsInList: function(item, $list) {
      var arr = [];

      $list.each(function() {
        arr.push($(this).text());
      });

      var check = false;

      for (var jint = 0; jint < arr.length; jint = jint + 1) {
        if (arr[jint] === item) {
          check = true;
        }
      }

      return check;
    }

  };

  /* eslint-enable no-use-before-define */
  function downloadFileInIE(data, fileName) {
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var byteCharacters = atob(data);
      var byteNumbers = [byteCharacters.length];

      for (var inc = 0; inc < byteCharacters.length; inc = inc + 1) {
        byteNumbers[inc] = byteCharacters.charCodeAt(inc);
      }

      var byteArray = new Uint8Array(byteNumbers);
      var blob = new Blob([byteArray], {
        type: 'application/pdf'
      });

      window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
  }

  $('document').ready(function() {
    PHI.shoppinglist.bindShoppingList();
    PHI.shoppinglist.bindShoppingListPopup();

    $('document').ready(function() {
      $('.viewBillingDoc').click(function() {
        ACC.omniture.trackConversion('interaction', 'click:Billing');

        var orderId = $(this).attr('data-orderId');
        var billDocNum = $(this).attr('data-billDocNum');
        var purchaseOrderRefNumber = $(this).attr('data-purchaseOrderRefNumber');
        var entryNum = $(this).attr('data-uniqueentrynum');
        var billingType = $(this).attr('data-billingType');

        $('.billing-detail-loader').hide();
        $('.' + entryNum).show();
        $.ajax({
          url: ACC.config.encodedContextPath + '/my-account/viewBillingDoc',
          data: {
            orderCode: orderId,
            billDocNum: billDocNum,
            purchaseOrderRefNumber: purchaseOrderRefNumber,
            billingType: billingType
          },
          type: 'POST',
          datatype: 'json',
          success: function(result) {
            $('.' + entryNum).hide();

            var obj = $.parseJSON(JSON.stringify(result));
            var popupElement = $.parseJSON(obj);

            $.colorbox({
              html: popupElement.billingDocumentPopup,
              width: '90%',
              height: '90%',
              overlayClose: true,
              onOpen: function() {
                $('body').css('overflow', 'hidden');

                $(document).on('click', '.phi-pdflink', function() {
                  $.ajax({
                    type: 'GET',
                    url: ACC.config.encodedContextPath + '/my-account/generateBillingDoc?billingDocId=' + billDocNum,
                    success: function(data) {
                      /* eslint-disable sonarjs/no-redundant-boolean */
                      var uri = 'data:application/pdf;base64, ' + data;
                      var link = document.createElement('a');
                      var isIE = false || Boolean(document.documentMode);

                      ACC.omniture.trackConversion('download', 'pdf');

                      /* eslint-enable sonarjs/no-redundant-boolean */
                      /* @cc_on!@*/
                      /* eslint-disable no-negated-condition */
                      if (!isIE) {
                        link.href = uri;
                        link.download = billDocNum + '.pdf';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      } else {
                        downloadFileInIE(data, billDocNum + '.pdf');
                      }
                      /* eslint-enable no-negated-condition */
                    },
                    error: function() {
                      $('#pdf-button').hide();
                      $('#pdf-error').show();
                      ACC.omniture.trackConversion('download', 'No_Invoice_Available');
                    }
                  });
                });
              },
              onComplete: function() {
                $('.ph-preicmipopup').each(function() {
                  if ($(this).html().trim() === '') {
                    $(this).prev('.ph-iconpreicmi').remove();
                  }
                });

                if ($('.ph-billingdocpopup, .ph-billingdocpopupwithoutdisc').length > 0) {
                  if ($('.ph-billingdocpopup, .ph-billingdocpopupwithoutdisc').find('.ph-popupsubtotal').find('.ph-popuptext').html().trim() === '') {
                    $('.ph-billingdocpopup, .ph-billingdocpopupwithoutdisc').find('.ph-icon').remove();
                  }
                }
              },
              onSubmit: function() {
                // As of now no functionality added
              },
              onClosed: function() {
                $('body').css('overflow', 'auto');
                $(document).off('click', '.phi-pdflink');
              }
            });
          },
          error: function() {
            $('.' + entryNum).hide();
          }
        });
      });

      $('.viewDeliveryDoc').click(function() {
        ACC.omniture.trackConversion('interaction', 'click:Delivery');

        var orderId = $(this).attr('data-orderId');
        var delivDocNum = $(this).attr('data-delivDocNum');
        var purchaseOrderRefNumber = $(this).attr('data-purchaseOrderRefNumber');
        var entryNum = $(this).attr('data-uniqueentrynum');
        var sapPlant = $(this).attr('data-sapPlant');
        var sapPlantDescription = $(this).attr('data-plantDescription');

        $('.billing-detail-loader').hide();
        $('.' + entryNum).show();
        $.ajax({
          url: ACC.config.encodedContextPath + '/my-account/viewDeliveryDoc',
          data: {
            orderCode: orderId,
            delivDocNum: delivDocNum,
            purchaseOrderRefNumber: purchaseOrderRefNumber,
            sapPlant: sapPlant,
            sapPlantDescription: sapPlantDescription
          },
          type: 'POST',
          datatype: 'json',
          success: function(result) {
            $('.' + entryNum).hide();

            var obj = $.parseJSON(JSON.stringify(result));
            var popupElement = $.parseJSON(obj);

            $.colorbox({
              html: popupElement.deliveryDocumentPopup,
              width: '90%',
              height: '90%',
              overlayClose: true,
              onOpen: function() {
                $('body').css('overflow', 'hidden');
              },
              onComplete: function() {
                /* eslint-disable sonarjs/no-identical-functions*/
                $('.ph-preicmipopup').each(function() {
                  /* eslint-enable sonarjs/no-identical-functions*/
                  if ($(this).html().trim() === '') {
                    $(this).prev('.ph-iconpreicmi').remove();
                  }
                });
              },
              onSubmit: function() {
                // As of now no functionality added
              },
              onClosed: function() {
                $('body').css('overflow', 'auto');
              }
            });
          },
          error: function() {
            $('.' + entryNum).hide();
          }
        });
      });
    });
  });

  // Implementation of back-order code start
  $(document).on('click', '.ph-checkallproducts .ph-selectall', function() {
    var shoplist = 'myshopping-list-viewfulllist',
        phquantity = '.ph-quantity',
        phdisablebtn = 'disablebutton',
        sellistName = '#' + $(this).closest('.order').attr('id'),
        disablebut = 'ph-disable-button';

    $(sellistName + ' .ph-checkbox:not(:disabled)').prop('checked', true);

    var checkboxstat = $(sellistName + ' .ph-checkbox:checked').length;

    if ($(phquantity).length > 0 && $('.ph-' + phdisablebtn).length === 0) {
      $(this).parent().parent().find('.' + shoplist).removeClass(disablebut);
    }

    if (checkboxstat <= 0) {
      $(this).parent().parent().find('.' + shoplist).addClass(disablebut);
    }

    PHI.shoppinglist.changeProductCheck();
  });


  $(document).on('click', '.ph-checkallproducts  .ph-deselectall', function() {
    var shoppinglst = 'viewfulllist',
        phdisable = 'ph-disable',
        checkbx = 'checkbox';

    $('.ph-' + checkbx).prop('checked', false);
    $(this).parent().parent().find('.myshopping-list-' + shoppinglst).addClass(phdisable + '-button');
    PHI.shoppinglist.changeProductCheck();
  });

  // Implementation of back-order code ends

  $(document).on('change', '.ph-checkbox', function() {
    var listName = $(this).attr('list-name'),
        disablebt = 'disable-button',
        listBtn = 'list-button-';

    listName = listName.replace(/\s+/g, '');

    var $elment = $('.myshopping-' + listBtn + listName);

    if ($(this).prop('checked') === false) {
      var isAllDeselected = true;
      var $allCheckBoxes = $('.checkbox-' + listName);

      for (var intgr = 0; intgr < $allCheckBoxes.length; intgr = intgr + 1) {
        if ($allCheckBoxes[intgr].checked === true) {
          isAllDeselected = false;

          break;
        }
      }

      if (isAllDeselected) {
        $elment.addClass('ph-' + disablebt);
      }

      PHI.shoppinglist.changeProductCheck();
    } else if ($('.ph-disablebutton').length === 0) {
      ACC.autocomplete.disableSAPEnableBtn('.myshopping-' + listBtn + listName, 'ph-' + disablebt);
    }
  });

  function checkBoxHandling(element) {
    var listName = $(element).attr('list-name');
    var listNameWithoutSpace1 = listName.replace(/\s+/g, '');
    var HiddenInputVal = $('#ph-selectedproduct-' + listNameWithoutSpace1).val();
    var CurrentCheckBoxValue = $(element).val();

    if ($(element).prop('checked') === true) {
      if (HiddenInputVal === '') {
        HiddenInputVal = CurrentCheckBoxValue;
      } else {
        HiddenInputVal = HiddenInputVal + (',' + CurrentCheckBoxValue);
      }

      $('#ph-selectedproduct-' + listNameWithoutSpace1).val(HiddenInputVal);
    } else if (HiddenInputVal.indexOf(CurrentCheckBoxValue) !== -1) {
      HiddenInputVal = HiddenInputVal.replace(CurrentCheckBoxValue, '');
      HiddenInputVal = HiddenInputVal.replace(',', '');
      $('#ph-selectedproduct-' + listNameWithoutSpace1).val(HiddenInputVal);
    }
  }

  $(document).on('click', '.ph-deleteshoppinglist', function() {
    $('#favRemoveCode').val($(this).attr('data-productid'));
    $('#removeFavForm').submit();
  });

  $(document).on('click', '.ph-closepopup', function() {
    $.colorbox.close();
  });

  if ($('.page-favoriteOrder .positive').length > 0) {
    setTimeout(function() {
      $('.page-favoriteOrder .positive').hide();
    }, 3000);
  }

  if ($('.page-cartPage .positive').length > 0) {
    setTimeout(function() {
      $('.page-cartPage .positive').hide();
    }, 3000);
  }

  $(document).on('click', '.ph-checkbox', function() {
    checkBoxHandling(this);
  });

  $('.myshopping-list-checkbox input[type=checkbox]').click(function() {
    if (!$(this).is(':checked')) {
      PHI.shoppinglist.changeProductCheck();
    }
  });
  $(document).on('click', '.myshopping-list-viewfulllist', function(event) {
    var zoomprodCount = $(this).parents('.ph-shoppingsearch').find('.zoomprod').length;

    if (zoomprodCount > 0) {
      $(this).attr('iszoomdelivered', 'true');
    } else {
      $(this).attr('iszoomdelivered', 'false');
    }

    if (ACC.common.showMixedCartCheck($(this)) === true) {
      ACC.common.showzoomDeliveredPopUp($(this).val());
      event.stopImmediatePropagation();
    }
  });
  $(document).on('click', '.myshopping-list-viewfulllist', function() {
    /* eslint-disable consistent-this */
    var self = this;
    /* eslint-enable consistent-this */
    var listName = $(this).attr('data-listname'),
        orderdet = '-order-details-',
        disablebuut = 'disable-button',
        shoppingsearchCls = '.ph-shoppingsearch',
        allproducts = [],
        quantityClass = 'quantity',
        productWithCode = '',
        productCodeNumb = 0;

    $(self).parents(shoppingsearchCls).css('pointer-events', 'none');
    $('#ph' + orderdet + listName).find('.quantity input').addClass('ph-' + disablebuut);
    $(self).parents(shoppingsearchCls).find('.ph-editlistbtn').addClass('ph-' + disablebuut);
    $(self).parents(shoppingsearchCls).find('.myshopping-list-viewfulllist').addClass('ph-' + disablebuut);
    $('.ph-myshopping-list-loader').show();
    $('#ph' + orderdet + listName).find('.ph-myshopping-list-row').each(function() {
      productWithCode = $(this).find('.ph-mainProductcode').val();
      productCodeNumb = parseInt(productWithCode, 10);

      if ($(this).find('.ph-' + quantityClass).val() > 0) {
        allproducts.push(productCodeNumb + ':' + $(this).find('.ph-' + quantityClass).val());
      }
    });
    $.ajax({
      url: ACC.config.encodedContextPath + '/shoppinglist/addListToCart',
      data: {
        addListToCartName: listName,
        products: allproducts.toString()
      },
      type: 'POST',
      datatype: 'json',
      success: function() {
        window.location = ACC.config.encodedContextPath + '/cart';
      },
      error: function() {
        $(self).removeClass('ph-' + disablebuut);
        $(self).parents(shoppingsearchCls).find('.ph-listquantity input').removeClass('ph-' + disablebuut);
        $(self).parents(shoppingsearchCls).find('.ph-editlistbtn').removeClass('disabled');
        $(self).removeClass('.ph-genreploadpointerevt');
        $('.ph-myshopping-list-loader').hide();
      }
    });
  });
});

$('document').ready(function() {
  $(document).on('click', '.ph-remove', function(event) {
    event.preventDefault();

    var productCode = $(this).attr('data-productCode'),
        toggleval = 'backorderfeaturetoggle',
        backordertoggle = $('#ph-' + toggleval).val(),
        listname = $(this).attr('data-listName'),
        listNameWithoutSpace = listname.replace(/\s+/g, ''),
        /* eslint-disable radix */
        productCount = parseInt($('#listProductCount' + listNameWithoutSpace).val()),
        parentShoppingDiv = $('#ph-order-details-' + listNameWithoutSpace).parents('.myshoppinglist-name').attr('id'),
        prodQtyCnt = $('#' + parentShoppingDiv).find('.fav_list_qty').html();

    /* eslint-enable radix */
    $.ajax({
      url: ACC.config.encodedContextPath + '/shoppinglist/removeProduct',
      data: {
        listName: listname,
        productCode: productCode

      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        var obj = $.parseJSON(JSON.stringify(result)),
            viewfulllistbut = 'myshopping-list-viewfulllist',
            qtyCount = '',
            disabledLength = '',
            errorText = '',
            parentdiv = ACC.autocomplete.orderDetailsId + listNameWithoutSpace,
            checkboxchecked = parentdiv + ' .ph-checkbox:checked',
            disbut = 'ph-disable-';
        /* eslint-enable max-statements */

        if (obj.status === 'success') {
          $('#cboxLoadedContent').find('#row' + productCode).remove();
          productCount = productCount - 1;
          qtyCount = parseInt(prodQtyCnt, 10) - 1;
          $('#' + parentShoppingDiv).find('.fav_list_qty').html(qtyCount);

          if (qtyCount === 0) {
            $('#' + parentShoppingDiv).find('.' + viewfulllistbut).addClass(disbut + 'button').prop('disabled', true);
            $('#' + parentShoppingDiv).find('.ph-selectall').addClass('ph-notactive-link');
            $('#' + parentShoppingDiv).find('.ph-deselectall').addClass('ph-notactive-link');
          } else {
            $('#' + parentShoppingDiv).find('.' + viewfulllistbut).removeClass(disbut + 'button').prop('disabled', false);
            $('#' + parentShoppingDiv).find('.ph-selectall').removeClass('ph-notactive-link');
            $('#' + parentShoppingDiv).find('.ph-deselectall').removeClass('ph-notactive-link');
          }
        } else if (obj.status === 'failure') {
          var $shoppingListMessage = $('.shoppingListAddToCartMessage');

          $shoppingListMessage.html(obj.removeMessage);
          $shoppingListMessage.addClass('information_message');
          $shoppingListMessage.addClass('negative');

          setTimeout(function() {
            $shoppingListMessage.html('');
            $shoppingListMessage.removeClass('information_message');
            $shoppingListMessage.removeClass('negative');
          }, 3000);
        }

        if (backordertoggle === 'true' && $(checkboxchecked).length === 0) {
          ACC.autocomplete.disableEnableCheckbox(productCode, 0);
          ACC.autocomplete.disableEnablebutton($('#' + parentShoppingDiv).find('.' + viewfulllistbut), 0);
        }

        if (backordertoggle === 'true' && $(checkboxchecked).length > 0) {
          ACC.autocomplete.disableEnableCheckbox(productCode, 1);
          ACC.autocomplete.disableEnablebutton($('#' + parentShoppingDiv).find('.' + viewfulllistbut), 1);
        }

        disabledLength = $(parentdiv + ' .ph-checkbox:disabled').length;

        errorText = $(parentdiv).find('.ph-lognostkerrormsg');
        ACC.autocomplete.disableEnableErrormsg(disabledLength, errorText, parentdiv);
      },
      error: function() {
        $('.shoppingListAddToCartMessage').html('');
      }
    });
  });
});
/* eslint-enable vars-on-top */
/* eslint-enable xss/no-mixed-html */
/* eslint-enable id-match */
/* eslint-enable no-undef */
/* eslint-enable max-lines-per-function */
/* eslint-enable max-lines */
